import styled from "styled-components";
import media from "styled-media-query";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Bloc = styled.div`
  background: ${({ theme }) => theme.colors.blueLight};
  display: flex;
  flex-direction: row;
  padding: 32px 40px;

  ${media.lessThan("small")`
    flex-direction: column;
  `}
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 90%;
  padding-left: 20px;
  justify-content:center;

  ${media.lessThan("small")`
    width: 100%;
    padding: 0px;
  `}

  a {
    color: ${({ theme }) => theme.colors.blue};
    text-decoration: underline;

    &:hover {
      font-weight:600;
    }
`;
export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 10%;

  ${media.lessThan("small")`
    width: 100%;
    margin-bottom:16px;
    justify-content:flex-start;
  `}
`;
